<form name="loginForm" novalidate (ngSubmit)="forward()" autocomplete="off" [ngClass]="{'form-complete': isFormCompleted}">
    <mat-form-field class="w-100">
        <mat-label for="login-new-input" [ngClass]="{'active' : loginID}">{{"copy.label.LOGIN.newlogin.label"|copy|async}}</mat-label>
        <input matInput required type="text" name="login-new-input" id="login-new-input" [(ngModel)]="loginID" alphanum />
    </mat-form-field>
    <span class="help-block"><a tabindex="0" (click)="openModal('LoginRegHelp', 'Registration Help', 'Close')" (keydown.enter)="openModal('LoginRegHelp', 'Registration Help', 'Close')">{{"copy.label.LOGIN.newlogin.help"|copy|async}}</a></span>
    <!-- <mat-form-field class="w-100" ng-if="loginCtrl.programInfo.regCode">
        <mat-label [ngClass]="{'active' : regcode}" for="regcode">{{"copy.label.LOGIN.regcode.label"|copy|async}}</mat-label>
        <input matInput type="text" name="regcode" id="regcode" aria-label="Registration/Promo code" [(ngModel)]="regcode" alphanum />
    </mat-form-field> -->
    <div class="button_group d-flex mt-2">
        <button aria-label="Decline" class="back btn btn-outline-primary" type="button" (click)="backhome()" *ngIf="!isSubmitting">Back To Home</button>
        <button class=" inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
        </button>
        <button *ngIf="!isSubmitting" name="new-login-button" type="submit" aria-label="Submit" class="forward btn btn-primary">{{'copy.label.LOGIN.newlogin.button'|copy|async}}</button>
    </div>

    <div *ngIf="errorMsg" type="danger">
        <strong>
            <span class="fas fa-stack">
            <i class="fas fa-exclamation fa-stack-1x"></i>
            <i class="far fa-circle fa-stack-2x"></i>
            </span>
            <span [innerHTML]="errorMsg"></span>
        </strong>
    </div>
</form>
